import apiService from './util/apiService'
import { REGION_GUESSER_URL } from '../config/constants/regionsConstants'

const VALID_COUNTRIES = [
  'ar',
  'bo',
  'br',
  'cl',
  'co',
  'ec',
  'gy',
  'py',
  'pe',
  'sr',
  'uy',
  've',
  'bz',
  'cr',
  'sv',
  'gt',
  'hn',
  'ni',
  'pa',
  'do',
  'es',
  'pt',
  'us',
  'mx'
]

// Map language variants to supported languages
const LANGUAGE_MAP = {
  es: 'es',
  ca: 'ca',
  eu: 'es',
  gl: 'es',
  pt: 'pt',
  en: 'en'
}

// Map region dropdown values to country codes
// Only specific countries - 'sa' (South America) and 'eu' (Europe) are regions, not countries
const REGION_TO_COUNTRY = {
  mx: 'mx',
  br: 'br',
  do: 'do'
}

// Detect language from browser locale
export function detectLanguage() {
  const stored = window.localStorage.getItem('bb_custom_language')
  if (stored && stored !== 'default') return stored

  const browserLang = (navigator.language || 'en').split('-')[0].toLowerCase()
  return LANGUAGE_MAP[browserLang] || 'en'
}

// Detect country - prioritize user's region selection, fallback to geo API
export async function detectCountry(selectedRegion) {
  // If user selected a specific country region, use it directly
  const regionValue = selectedRegion?.value
  if (regionValue && REGION_TO_COUNTRY[regionValue]) {
    return REGION_TO_COUNTRY[regionValue]
  }

  // Fallback to geo API for 'eu', 'sa', or no selection
  try {
    const response = await apiService.fetchGlobal(REGION_GUESSER_URL)
    const countryCode = response?.country?.toLowerCase()
    return VALID_COUNTRIES.includes(countryCode) ? countryCode : null
  } catch (error) {
    console.error('Failed to detect country:', error)
    return null
  }
}

// Check if user has custom language set
export function hasCustomLanguageSet() {
  const stored = window.localStorage.getItem('bb_custom_language')
  return stored && stored !== 'default'
}
